/**
 * CapturedImagesRow — Reusable horizontal scrollable row of captured product images.
 * Used by ClassificationProgressScreen and ResultsPage (AI-research flow).
 */

import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import "./classification.scss";

interface CapturedImagesRowProps {
  images: string[];
  title?: string;
  badgeLabel?: string;
}

const CapturedImagesRow: React.FC<CapturedImagesRowProps> = ({
  images,
  title = "Captured Product Views",
  badgeLabel,
}) => {
  if (images.length === 0) return null;

  return (
    <Column spacing="400" spacingInset="200">
      <Text type="h100" color="secondary">{title}</Text>
      <Row overflowX="scroll" spacing="300" spacingInset="200">
        {images.map((img, idx) => (
          <div key={idx} className="captured-images-scroll__item">
            {badgeLabel && (
              <span className="captured-images-scroll__badge">{badgeLabel}</span>
            )}
            <img src={img} alt={`Captured ${idx + 1}`} className="captured-images-scroll__img" />
          </div>
        ))}
      </Row>
    </Column>
  );
};

export default CapturedImagesRow;
